import { RootState } from '@store/redux.store'
import type { TaskTrackerState } from '../index'
import { createEmptyBoardAutomationsBoardState } from './boardAutomations.state.utils'

type AppState = RootState & {
  taskTracker: TaskTrackerState
}

export const selectTaskTrackerBoardAutomations = (
  state: AppState,
  boardId: number | null,
) => {
  if (boardId == null) return createEmptyBoardAutomationsBoardState()
  return (
    state.taskTracker.boardAutomations.byBoardId[boardId] ??
    createEmptyBoardAutomationsBoardState()
  )
}
